var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import base from './base';
import career from './career';
import experienceClasses from './experienceClasses';
import middleTask from './middleTask';
import organization from './organization';
import position from './position';
import projectCareer from './projectCareer';
import relatedDocument from './relatedDocument';
import relatedLink from './relatedLink';
import relatedPortfolio from './relatedPortfolio';
import relatedSolution from './relatedSolution';
export const consultantValidate = {
    asyncForm: (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        if (fieldName) {
            const isRelatedUrl = fieldName.match(/information\.relatedSolutions\[\d+?]\.url/);
            if (isRelatedUrl) {
                yield relatedSolution.asyncUrl(values, dispatch, formProp, fieldName);
            }
        }
    }),
    base,
    career,
    experienceClasses,
    middleTask,
    organization,
    position,
    projectCareer,
    relatedDocument,
    relatedLink,
    relatedPortfolio,
    relatedSolution,
};
export default consultantValidate;
